import { gameAssets } from "@pindou/game-assets";
import { createGameScreen, type GameScreenHandle } from "./ui/game-screen";
import { createHomeScreen } from "./ui/home-screen";

export class BeadHomecomingApp {
  private energy = 10;
  private coins = 1434;
  private activeGame: GameScreenHandle | null = null;

  public constructor(private readonly root: HTMLElement) {
    root.style.setProperty("--game-background", `url("${gameAssets.lavenderBackground}")`);
  }

  public start(): void {
    if (new URLSearchParams(window.location.search).get("play") === "1") {
      this.showGame(false);
      return;
    }
    this.showHome();
  }

  private showHome(): void {
    this.activeGame?.destroy();
    this.activeGame = null;
    createHomeScreen(this.root, {
      mascotUrl: gameAssets.beanShopkeeper,
      coins: this.coins,
      energy: this.energy,
      onStart: () => this.showLoadingThenGame(),
    });
  }

  private showLoadingThenGame(): void {
    if (this.energy <= 0) {
      return;
    }
    this.energy -= 1;
    this.root.innerHTML = `
      <section class="screen loading-screen" aria-label="正在加载关卡">
        <div class="loading-beads" aria-hidden="true"><i></i><i></i><i></i><i></i><i></i></div>
        <strong>加载中…</strong>
        <small>正在整理拼豆，请稍候</small>
      </section>`;
    window.setTimeout(() => this.showGame(true), 680);
  }

  private showGame(useIntro: boolean): void {
    this.activeGame?.destroy();
    this.activeGame = createGameScreen(this.root, {
      trayFrameUrl: gameAssets.trayFrame,
      useIntro,
      onHome: () => this.showHome(),
    });
  }
}
